import api from '@/api';
import _ from 'lodash';
const { DateTime } = require('luxon');

export default {
    namespaced: true,
    state: {
        contratos: [],
        blockchainEnabled: false,
    },
    getters: {
        contratos: state => state.contratos,
        blockchainEnabled: state => state.blockchainEnabled,
    },
    mutations: {
        SET_CONTRATOS(state, contratos) {
            state.contratos = contratos;
        },
        SET_BLOCKCHAIN_STATUS(state, blockchainEnabled) {
            state.blockchainEnabled = blockchainEnabled;
        },
    },
    actions: {
        getContratos({ commit }) {
            console.log('contratos');
            return new Promise((resolve, reject) => {
                api.get('/contracts')
                    .then(ans => {
                        if (ans.data) {
                            const contratos = (
                                _.get(ans, 'data.contracts') || []
                            ).map(contrato => {
                                contrato.timestamp = DateTime.fromISO(
                                    contrato.timestamp
                                ).toLocaleString(DateTime.DATETIME_MED);
                                return contrato;
                            });
                            commit('SET_CONTRATOS', contratos);
                        } else {
                            console.error(ans);
                        }
                        resolve();
                    })
                    .catch(error => {
                        commit('SET_CONTRATOS', []);
                        reject(error);
                    });
            });
        },
        deploy() {
            return new Promise((resolve, reject) => {
                api.post('/deploy-contract')
                    .then(res => {
                        if (res.status !== 200 && res.data) {
                            return reject(res.data.reason);
                        }
                        if (!res.data.adress_contract) {
                            return reject('No se pudo crear el contrato');
                        }

                        resolve(true);
                    })
                    .catch(reject);
            });
        },
        deleteContracts() {
            return new Promise(function(resolve, reject) {
                api.delete('/contracts')
                    .then(() => {
                        resolve();
                    })
                    .catch(reject);
            });
        },
        toogleBlockchain() {
            return new Promise((resolve, reject) => {
                api.put('/blockchain-configuration')
                    .then(res => {
                        const { isRunning } = res;

                        resolve({ isRunning });
                    })
                    .catch(reject);
            });
        },
        getBlockchainStatus({ commit }) {
            return new Promise((resolve, reject) => {
                api.get('/blockchain-configuration')
                    .then(res => {
                        const { isRunning } = res.data;

                        commit('SET_BLOCKCHAIN_STATUS', isRunning);
                        resolve({ isRunning });
                    })
                    .catch(reject);
            });
        },
    },
};
